import React from 'react';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';

import './DraftInfoTop.pcss';

import DraftIcon from './private/DraftIcon/DraftIcon';
import { SubmitModelProps } from '../../../models/submit';
import { getDraftTime, getRecoveredFromDraft } from '../../../selectors/submit';

interface Props {
  isVisible: boolean;

  onResetForm(): void;
}
type DraftInfoTopProps = Props & Pick<SubmitModelProps, 'draftTime'>;

function DraftInfoTop({
  draftTime,
  isVisible,
  onResetForm,
}: DraftInfoTopProps) {
  if (!isVisible) return null;

  return (
    <div className="DraftInfoTop">
      <div className="DraftIcon">
        <DraftIcon />
      </div>

      <div className="StepContentBlock">
        Заявление загружено из последнего автосохранения{' '}
        <span className="noWrapText">от {draftTime}.</span>
        <br />
        Вы можете продолжить оформление заявления или{' '}
        <button onClick={onResetForm} className={'mos-link'}>
          начать оформление заявки заново
        </button>
        .
      </div>
    </div>
  );
}

const mapStateToProps = createStructuredSelector({
  draftTime: getDraftTime,
  isVisible: getRecoveredFromDraft,
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  onResetForm: () => dispatch({ type: 'form/reset' }),
});
export default connect(mapStateToProps, mapDispatchToProps)(DraftInfoTop);
